module.exports = __webpack_public_path__ + "static/media/questionDefault.58719f5d.svg";